// // @ts-nocheck
// import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
// import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
// import EditSlot from "./EditSlot";
// import { daysList } from "../../../StaticData";
// import { toast } from "react-toastify";
// import { post, put } from "../../../../Services/ApiHandler";
// import { URLS } from "../../../../Services/Constant";
// import moment from "moment";

// const customStyles = {
//   control: (provided, state) => ({
//     ...provided,
//     backgroundColor: "#F4F4F4",
//     borderColor: state.isFocused ? "#333" : "#ccc",
//     boxShadow: state.isFocused ? "0 0 0 1px #333" : "none",
//     "&:hover": {
//       borderColor: "#333",
//     },
//   }),
// };

// const MondaySlot = ({
//   slotData,
//   viewOnly,
//   property_id,
//   room_id,
//   viewPrices,
// }) => {
//   const addSlotRef = useRef(null);
//   const [data, setData] = useState({
//     slotType: "",
//     slotTime: "",
//     propPrice: "",
//     vowCommission: "",
//     extraPrice: "",
//     extraCommission: "",
//     same_price: [],
//   });
//   const [openSlot, setOpenSlot] = useState(false);

//   const [slotObj, setSlotObj] = useState({});

//   const handleEdit = (item, sno, name) => {
//     const {
//       extra_person_commision,
//       extra_person_price,
//       id,
//       property_price,
//       same_price_for,
//       vow_commision,
//       time_slot,
//     } = item;
//     let finded = slotData?.blocked_slots?.find(
//       (item) => item?.value === time_slot,
//     );
//     setData({
//       name: name,
//       sno: sno,
//       id: id,
//       slotType: finded,
//       slotTime: { value: finded?.id, label: finded?.timeslot_type },
//       propPrice: property_price,
//       vowCommission: vow_commision,
//       extraPrice: extra_person_price,
//       extraCommission: extra_person_commision,
//       same_price: same_price_for ?? [],
//     });
//   };

//   useEffect(() => {
//     setOpenSlot(false);
//     setData({
//       slotType: "",
//       propPrice: "",
//       vowCommission: "",
//       extraPrice: "",
//       extraCommission: "",
//       same_price: [],
//       slotTime: "",
//     });
//   }, [slotData]);

//   const handleSlotSubmit = async () => {
//     if (!data?.slotType) {
//       toast.error("Slot Type  is required");
//       return;
//     }
//     if (!data?.slotTime) {
//       toast.error("Slot Time  is required");
//       return;
//     }
//     if (!data?.propPrice) {
//       toast.error("Property Price is required");
//       return;
//     }
//     if (!data?.vowCommission) {
//       toast.error("Vow Commission is required");
//       return;
//     }
//     // if (!data?.extraPrice) {
//     //   toast.error("Extra Price  is required");
//     //   return;
//     // }
//     // if (!data?.extraCommission) {
//     //   toast.error("Extra Commission is required");
//     //   return;
//     // }
//     let payload = {
//       property: property_id,
//       property_room: room_id,
//       time_slot: data?.slotTime?.value,
//       property_price: data?.propPrice,
//       vow_commision: data?.vowCommission,
//       extra_person_price: data?.extraPrice ? data?.extraPrice : 0,
//       extra_person_commision: data?.extraCommission ? data?.extraCommission : 0,
//       price_for: slotData?.currentSlot,
//     };
//     if (data?.same_price?.length !== 0) {
//       payload = { ...payload, same_price_for: data?.same_price };
//     }
//     let url = `${URLS.PROPERTY_ROOM_CREATE_MASTER}${
//       data?.id ? data?.id + "/edit/" : "create/"
//     }`;
//     let method = data?.id ? put : post;
//     const res = await method(url, payload);
//     console.log("slot create", res);
//     if (res?.status === "success") {
//       toast.success(res?.message);
//       viewPrices?.();
//       setData({
//         slotType: "",
//         propPrice: "",
//         vowCommission: "",
//         extraPrice: "",
//         extraCommission: "",
//         same_price: [],
//         slotTime: "",
//       });
//     }
//   };

//   useEffect(() => {
//     if (openSlot && addSlotRef.current) {
//       addSlotRef.current.scrollIntoView({
//         behavior: "smooth",
//         block: "center",
//       });
//     }
//   }, [openSlot]);

//   const formatTime = (time) => {
//     return time < 12
//       ? time + "AM"
//       : time === 12
//         ? time + "PM"
//         : time - 12 + "PM";
//   };
//   return (
//     <div>
//       <div className="d-flex as-jb mt-4">
//         <div className="slot-box ">
//           <p className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-20 mb-2">
//             Created Slot :{" "}
//             <span className="sec fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14">
//               {slotData?.createdSlots}
//             </span>
//           </p>
//           <p className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-20 mb-1">
//             Not Created Slot :{" "}
//             <span className="sec fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14">
//               {slotData?.balanceSlots}
//             </span>
//           </p>
//         </div>
//         {!viewOnly && slotData?.balanceSlots && (
//           <button
//             onClick={() => {
//               setOpenSlot("add");
//               setData({
//                 slotType: "",
//                 propPrice: "",
//                 vowCommission: "",
//                 extraPrice: "",
//                 extraCommission: "",
//                 same_price: [],
//                 slotTime: "",
//               });
//             }}
//             className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
//           >
//             {" "}
//             + Add Slot
//           </button>
//         )}
//       </div>
//       {slotData?.slotsList?.map((slotName, index) => {
//         let start = moment(slotName?.start_time, "HH:mm:ss");
//         let end = moment(slotName?.end_time, "HH:mm:ss");
//         let start_hrs = start.get("hours");
//         let end_hrs = end.get("hours");
//         let hrs = end_hrs - start_hrs;
//         let total_hrs = hrs < 0 ? hrs + 24 : hrs;
//         let name = `${total_hrs} hrs, ${formatTime(start_hrs)} - ${formatTime(
//           end_hrs,
//         )}`;
//         let slot_status = slotName?.status;
//         let slot_id = slotName?.id;

//         if (slotObj[slot_id] === undefined) {
//           slotObj[slot_id] = slot_status;
//         }

//         console.log("slotName", slotName, "slot_id", slot_id);
//         console.log("slot_status", slot_status);

//         // console.log("slotData", slotData);
//         return (
//           <div>
//             <div className="slot-box mt-4">
//               <div className="d-flex ac-jb">
//                 <div className="col-md-7">
//                   <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-20 mb-1">
//                     Slot {index + 1} <span className="f4">({name})</span>
//                   </p>
//                   <div className="d-flex gap-3 mt-4 ">
//                     {daysList.map((day, index) => {
//                       if (day === slotData?.currentSlot) {
//                         return null;
//                       }
//                       let samePrice = slotName?.same_price_for?.includes(day);
//                       return (
//                         <span className="d-flex ac-js gap-1">
//                           <p
//                             className={`slot-check${samePrice ? "" : "-off"}`}
//                           ></p>
//                           <p className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-20 ">
//                             {day?.substring(0, 3)}
//                           </p>
//                         </span>
//                       );
//                     })}
//                   </div>
//                 </div>

//                 <button
//                   className={`${
//                     !slotObj[slot_id] ? "deactive-btn" : "active-btn"
//                   } border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 `}
//                   style={{
//                     cursor: "not-allowed",
//                   }}
//                 >
//                   {!slotObj[slot_id] ? "De-active" : "Active"}
//                 </button>

//                 <ArrowForwardIosRoundedIcon
//                   style={{
//                     rotate: slotName?.id === openSlot ? "90deg" : "0deg",
//                   }}
//                   className="pointer"
//                   onClick={() => {
//                     setOpenSlot(
//                       slotName?.id === openSlot ? false : slotName?.id,
//                     );
//                     handleEdit(slotName, index + 1, name);
//                   }}
//                 />
//               </div>
//             </div>
//             {openSlot === slotName?.id && (
//               <EditSlot
//                 ref={addSlotRef}
//                 slotId={openSlot}
//                 viewOnly={viewOnly}
//                 currentSlot={slotData?.currentSlot}
//                 customStyles={customStyles}
//                 availableSlots={slotData?.availableSlots}
//                 data={data}
//                 setData={setData}
//                 handleSlotSubmit={handleSlotSubmit}
//                 setSlotObj={setSlotObj}
//                 slotStatus={slotObj[slot_id]}
//                 slot_id={slot_id}
//                 viewPrices={viewPrices}
//               />
//             )}
//           </div>
//         );
//       })}
//       {openSlot === "add" && (
//         <EditSlot
//           ref={addSlotRef}
//           slotId={openSlot}
//           viewOnly={viewOnly}
//           currentSlot={slotData?.currentSlot}
//           customStyles={customStyles}
//           availableSlots={slotData?.availableSlots}
//           data={data}
//           setData={setData}
//           handleSlotSubmit={handleSlotSubmit}
//         />
//       )}
//     </div>
//   );
// };

// export default MondaySlot;
// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import EditSlot from "./EditSlot";
import { daysList } from "../../../StaticData";
import { toast } from "react-toastify";
import { post, put } from "../../../../Services/ApiHandler";
import { URLS } from "../../../../Services/Constant";
import moment from "moment";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#F4F4F4",
    borderColor: state.isFocused ? "#333" : "#ccc",
    boxShadow: state.isFocused ? "0 0 0 1px #333" : "none",
    "&:hover": { borderColor: "#333" },
  }),
};

const MondaySlot = ({
  slotData,
  viewOnly,
  property_id,
  room_id,
  viewPrices,
}) => {
  const addSlotRef = useRef(null);
  const [data, setData] = useState({
    slotType: "",
    slotTime: "",
    propPrice: "",
    vowCommission: "",
    extraPrice: "",
    extraCommission: "",
    same_price: [],
  });
  const [openSlot, setOpenSlot] = useState(false);
  const [slotObj, setSlotObj] = useState({});

  // ✅ Properly sync slotObj from slotData (replaces direct mutation in render)
  useEffect(() => {
    if (slotData?.slotsList) {
      const initialStatuses = {};
      slotData.slotsList.forEach((slot) => {
        initialStatuses[slot.id] = slot.status;
      });
      setSlotObj(initialStatuses);
    }
  }, [slotData]);

  const handleEdit = (item, sno, name) => {
    const {
      extra_person_commision,
      extra_person_price,
      id,
      property_price,
      same_price_for,
      vow_commision,
      time_slot,
    } = item;
    let finded = slotData?.blocked_slots?.find(
      (item) => item?.value === time_slot,
    );
    setData({
      name,
      sno,
      id,
      slotType: finded,
      slotTime: { value: finded?.id, label: finded?.timeslot_type },
      propPrice: property_price,
      vowCommission: vow_commision,
      extraPrice: extra_person_price,
      extraCommission: extra_person_commision,
      same_price: same_price_for ?? [],
    });
  };

  useEffect(() => {
    setOpenSlot(false);
    setData({
      slotType: "",
      propPrice: "",
      vowCommission: "",
      extraPrice: "",
      extraCommission: "",
      same_price: [],
      slotTime: "",
    });
  }, [slotData]);

  const handleSlotSubmit = async () => {
    if (!data?.slotType) return toast.error("Slot Type is required");
    if (!data?.slotTime) return toast.error("Slot Time is required");
    if (!data?.propPrice) return toast.error("Property Price is required");
    if (!data?.vowCommission) return toast.error("Vow Commission is required");

    let payload = {
      property: property_id,
      property_room: room_id,
      time_slot: data?.slotTime?.value,
      property_price: data?.propPrice,
      vow_commision: data?.vowCommission,
      extra_person_price: data?.extraPrice || 0,
      extra_person_commision: data?.extraCommission || 0,
      price_for: slotData?.currentSlot,
    };
    if (data?.same_price?.length !== 0) {
      payload = { ...payload, same_price_for: data?.same_price };
    }

    const url = `${URLS.PROPERTY_ROOM_CREATE_MASTER}${data?.id ? data.id + "/edit/" : "create/"}`;
    const method = data?.id ? put : post;
    const res = await method(url, payload);

    if (res?.status === "success") {
      toast.success(res?.message);
      viewPrices?.();
      setData({
        slotType: "",
        propPrice: "",
        vowCommission: "",
        extraPrice: "",
        extraCommission: "",
        same_price: [],
        slotTime: "",
      });
    }
  };

  useEffect(() => {
    if (openSlot && addSlotRef.current) {
      addSlotRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [openSlot]);

  const formatTime = (time) =>
    time < 12 ? time + "AM" : time === 12 ? time + "PM" : time - 12 + "PM";

  return (
    <div>
      <div className="d-flex as-jb mt-4">
        <div className="slot-box">
          <p className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-20 mb-2">
            Created Slot :{" "}
            <span className="sec fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14">
              {slotData?.createdSlots}
            </span>
          </p>
          <p className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-20 mb-1">
            Not Created Slot :{" "}
            <span className="sec fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14">
              {slotData?.balanceSlots}
            </span>
          </p>
        </div>
        {!viewOnly && slotData?.balanceSlots && (
          <button
            onClick={() => {
              setOpenSlot("add");
              setData({
                slotType: "",
                propPrice: "",
                vowCommission: "",
                extraPrice: "",
                extraCommission: "",
                same_price: [],
                slotTime: "",
              });
            }}
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn"
          >
            + Add Slot
          </button>
        )}
      </div>

      {slotData?.slotsList?.map((slotName, index) => {
        const start = moment(slotName?.start_time, "HH:mm:ss");
        const end = moment(slotName?.end_time, "HH:mm:ss");
        const start_hrs = start.get("hours");
        const end_hrs = end.get("hours");
        const hrs = end_hrs - start_hrs;
        const total_hrs = hrs < 0 ? hrs + 24 : hrs;
        const name = `${total_hrs} hrs, ${formatTime(start_hrs)} - ${formatTime(end_hrs)}`;
        const slot_id = slotName?.id;

        // ✅ Read status from reactive slotObj state (not direct mutation)
        const slot_status = slotObj[slot_id];

        return (
          <div key={slot_id}>
            <div className="slot-box mt-4">
              <div className="d-flex ac-jb">
                <div className="col-md-7">
                  <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-20 mb-1">
                    Slot {index + 1} <span className="f4">({name})</span>
                  </p>
                  <div className="d-flex gap-3 mt-4">
                    {daysList.map((day) => {
                      if (day === slotData?.currentSlot) return null;
                      const samePrice = slotName?.same_price_for?.includes(day);
                      return (
                        <span key={day} className="d-flex ac-js gap-1">
                          <p
                            className={`slot-check${samePrice ? "" : "-off"}`}
                          ></p>
                          <p className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-20">
                            {day?.substring(0, 3)}
                          </p>
                        </span>
                      );
                    })}
                  </div>
                </div>

                <button
                  className={`${!slot_status ? "deactive-btn" : "active-btn"} border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13`}
                  style={{ cursor: "not-allowed" }}
                >
                  {!slot_status ? "De-active" : "Active"}
                </button>

                <ArrowForwardIosRoundedIcon
                  style={{
                    rotate: slotName?.id === openSlot ? "90deg" : "0deg",
                  }}
                  className="pointer"
                  onClick={() => {
                    setOpenSlot(
                      slotName?.id === openSlot ? false : slotName?.id,
                    );
                    handleEdit(slotName, index + 1, name);
                  }}
                />
              </div>
            </div>

            {openSlot === slotName?.id && (
              <EditSlot
                ref={addSlotRef}
                slotId={openSlot}
                viewOnly={viewOnly}
                currentSlot={slotData?.currentSlot}
                customStyles={customStyles}
                availableSlots={slotData?.availableSlots}
                data={data}
                setData={setData}
                handleSlotSubmit={handleSlotSubmit}
                setSlotObj={setSlotObj}
                slotStatus={slot_status} // ✅ Now reactive
                slot_id={slot_id}
                viewPrices={viewPrices}
              />
            )}
          </div>
        );
      })}

      {openSlot === "add" && (
        <EditSlot
          ref={addSlotRef}
          slotId={openSlot}
          viewOnly={viewOnly}
          currentSlot={slotData?.currentSlot}
          customStyles={customStyles}
          availableSlots={slotData?.availableSlots}
          data={data}
          setData={setData}
          handleSlotSubmit={handleSlotSubmit}
        />
      )}
    </div>
  );
};

export default MondaySlot;
